module.exports = __webpack_public_path__ + "static/media/calc.287dd358.png";